import React from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { KiteMenu, KiteMenuItem } from '@kite/react-kite'
import { ReactComponent as SpectrumLogo } from '../../assets/images/specttrum_logo_white.svg'
import { ReactComponent as MSMLogo } from '../../assets/images/msm_logo.svg'
import { ILink } from '../../types'

import './HeaderStyles.scss'
import { useSelector } from 'react-redux'
import { selectLoggedInUserEmail } from '../../redux/User/Selector'
import { isUserAuthenticated } from '../../utils/TokenManager'

interface IHeaderProps {
  links: Array<ILink>,
  onSignOut: () => void
}

const Header = ({ links, onSignOut }: IHeaderProps) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const email = useSelector(selectLoggedInUserEmail);
  const isAuthenticated = isUserAuthenticated();
  const activeClassName = 'link link-active'
  const handleChildClick = (link: ILink) => {
    navigate(link?.link)
  }
  return (
    <header>
      <div className='logo-container left'>
        <div className='spectrum-logo' role='presentation'>
          <SpectrumLogo />
        </div>
      </div>
      {isAuthenticated && (
        <>
          <div className='links-container center'>
            {links.map((link, index) => {
              if (link?.children) {
                return (
                  <span
                    key={index}
                    className={
                      pathname?.includes(link?.link)
                        ? activeClassName + ' link dropdown-link'
                        : ' link dropdown-link'
                    }
                  >
                    <KiteMenu variant='flow' label={link?.label}>
                      {(link.children || []).map((childLink, j) => {
                        return (
                          <KiteMenuItem
                            onClick={() => handleChildClick(childLink)}
                            key={j}
                            disabled={childLink?.disabled}
                          >
                            {childLink?.label}
                          </KiteMenuItem>
                        )
                      })}
                    </KiteMenu>
                  </span>
                )
              }
              return (
                <NavLink
                  key={index}
                  className={({ isActive }) => (isActive ? activeClassName : 'link')}
                  to={link.link}
                >
                  {link?.label}
                </NavLink>
              )
            })}
          </div>
          <div className='right'>
            <div className='user-menu'>
              <KiteMenu variant='flow' label={email}>
                <KiteMenuItem onClick={onSignOut}>Sign Out</KiteMenuItem>
              </KiteMenu>
            </div>
          </div>
        </>
      )}
    </header>
  )
}

export default Header
